import http from "@/utils/http";
//查询用户信息
export const queryUser = uuid => http.get('/api/getUserAttributeForMobile.htm', {id: uuid})
//查询当前登录用户信息
export const queryUserLogin = () => http.get('/user/queryLoginUser.htm')
// 密码登录
export const loginByPwd = (params) => http.post('/nonlogin/mobile/login.htm', params);
//退出登录
export const logout = () => http.post('/login/logoutForAjax.htm');
//查询模板变量
export const globalThemeParams= () => http.get('/nonlogin/basic/getInfo.htm');
//查询底部导航
export const globalTabbar = () => http.get('/nonlogin/mobile/navigation/queryVisible.htm');
